import { render } from "./FolderContainer.vue?vue&type=template&id=aeb721d2&scoped=true"
import script from "./FolderContainer.vue?vue&type=script&lang=js"
export * from "./FolderContainer.vue?vue&type=script&lang=js"

import "./FolderContainer.vue?vue&type=style&index=0&id=aeb721d2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeb721d2"]])

export default __exports__